module.exports = __webpack_public_path__ + "img/job-profile2.ede7d9e8.png";